export default {
  path: '',
  component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
  children: [
    {
      path: '/distributor/train/front/search',
      name: 'distributor-train-front-search',
      component: () => import('./index.vue'),
    },
  ]
};
